import React from 'react';

/**
 * Generic loading atom (reused from previous package pattern).
 */
export default function Loading({ text = 'Loading', fullScreen = false }) {
  return (
    <div
      className="ca-loading"
      style={fullScreen ? { minHeight: 'calc(100vh - 80px)' } : undefined}
      role="status"
      aria-live="polite"
    >
      <span className="ca-loading__spinner" />
      <span>{text}…</span>
    </div>
  );
}
